<template>
  <section class="apple-products-editor">
    <div class="form-section product-section">
    <div class="panel-section-header">
      <div class="panel-title-icon"><i class="el-icon-tickets"></i></div>
      <div>
        <h3 class="panel-section-title">商品挡位明细</h3>
        <p class="section-subtitle">独立维护 Apple 应用商品，不关联游戏商品挡位。</p>
      </div>
    </div>

    <div class="table-container">
      <el-table :data="products" stripe style="width: 100%" class="premium-table inline-edit-table">
        <el-table-column label="商品 ID" min-width="130">
          <template slot-scope="scope">
            <el-input v-model="scope.row.id" placeholder="商品ID" size="small" @input="syncToForm"></el-input>
          </template>
        </el-table-column>

        <el-table-column label="价格（分）" width="130">
          <template slot-scope="scope">
            <el-input v-model.number="scope.row.price" placeholder="价格" size="small" type="number" @input="syncToForm"></el-input>
          </template>
        </el-table-column>

        <el-table-column label="商品名称" min-width="150">
          <template slot-scope="scope">
            <el-input v-model="scope.row.name" placeholder="商品名称" size="small" @input="syncToForm"></el-input>
          </template>
        </el-table-column>

        <el-table-column label="商品描述" min-width="220">
          <template slot-scope="scope">
            <el-input v-model="scope.row.desc" placeholder="商品描述" size="small" @input="syncToForm"></el-input>
          </template>
        </el-table-column>

        <el-table-column label="渠道商品ID" min-width="160">
          <template slot-scope="scope">
            <el-input v-model="scope.row.cid" placeholder="渠道商品ID" size="small" @input="syncToForm"></el-input>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="76" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" circle icon="el-icon-delete" plain @click="handleDeleteParams(scope.$index)"></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="toolbar-row">
      <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAddParams" class="btn-primary-action">添加单行</el-button>

      <el-button size="small" icon="el-icon-download" plain @click="handleExportTemplate">导出 Excel 模板</el-button>

      <el-upload action="" :auto-upload="false" :show-file-list="false" accept=".xlsx,.xls,.csv" :on-change="handleAddFile" class="upload-inline">
        <el-button size="small" icon="el-icon-upload2" plain>导入 Excel</el-button>
      </el-upload>
    </div>
    </div>

    <div class="form-section json-section">
      <div class="panel-section-header compact-header">
        <div class="panel-title-icon"><i class="el-icon-document"></i></div>
        <div>
          <h3 class="panel-section-title">查看/编辑 JSON</h3>
          <p class="section-subtitle">默认展示当前商品挡位 JSON，可切换到编辑模式后批量应用。</p>
        </div>
        <el-radio-group v-model="jsonMode" size="mini" class="json-mode-switch" @change="handleJsonModeChange">
          <el-radio-button label="view">查看</el-radio-button>
          <el-radio-button label="edit">编辑</el-radio-button>
        </el-radio-group>
      </div>
      <pre v-if="jsonMode === 'view'" class="json-preview">{{ formattedProductsJson }}</pre>
      <div v-else class="json-editor">
        <el-input type="textarea" :rows="8" placeholder='请输入 JSON 数据，例如：[{"id":"101","price":600,"name":"6元礼包","desc":"测试描述","cid":"apple_product_6"}]' v-model="textarea" class="code-textarea"></el-input>
        <div class="section-actions">
          <el-button type="success" size="small" icon="el-icon-check" @click="handleFormatJson">应用 JSON</el-button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AppleProducts',
  props: {
    form: {
      type: Object,
      required: true
    },
    prop: {
      type: String,
      default: 'products'
    }
  },
  data () {
    return {
      products: [],
      textarea: '',
      jsonMode: 'view'
    }
  },
  computed: {
    formattedProductsJson () {
      return JSON.stringify(this.getPersistProducts(), null, 2)
    }
  },
  watch: {
    form: {
      handler (newForm) {
        if (newForm) {
          this.init()
        }
      },
      immediate: true
    }
  },
  methods: {
    // Apple 商品挡位独立于游戏商品配置
    init () {
      let val = this.form[this.prop]
      if (typeof val === 'string') {
        try {
          val = JSON.parse(val)
        } catch (e) {
          val = []
        }
      }
      this.products = Array.isArray(val) ? JSON.parse(JSON.stringify(val)) : []
      this.syncToForm()
    },
    // 同步写回
    syncToForm () {
      this.$set(this.form, this.prop, this.getPersistProducts())
    },
    getPersistProducts () {
      return this.products
        .filter(item => item.id !== undefined && item.id !== null && String(item.id).trim())
        .map(item => ({
          id: String(item.id),
          price: item.price,
          name: item.name || '',
          desc: item.desc || '',
          cid: item.cid || ''
        }))
    },
    // 添加参数
    handleAddParams () {
      const params = { id: '', name: '', price: 0, desc: '', cid: '' }
      this.products.push(params)
      this.syncToForm()
    },
    // 删除参数
    handleDeleteParams (i) {
      this.products.splice(i, 1)
      this.syncToForm()
    },
    handleJsonModeChange (mode) {
      if (mode === 'edit') this.textarea = this.formattedProductsJson
    },
    handleExportTemplate () {
      const XLSX = require('xlsx')
      const rows = this.getPersistProducts()
      const worksheet = XLSX.utils.json_to_sheet([
        { id: '商品ID', price: '价格（分）', name: '商品名称', desc: '商品描述', cid: '渠道商品ID' },
        ...(rows.length ? rows : [{ id: '101', price: 600, name: '6元礼包', desc: '示例描述', cid: 'apple_product_6' }])
      ], { skipHeader: true })
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, '商品挡位')
      XLSX.writeFile(workbook, 'Apple应用商品挡位.xlsx')
    },
    // 文件导入
    handleAddFile (uploadFile) {
      if (!uploadFile || !uploadFile.raw) {
        return this.$message.warning('请选择文件')
      }

      const reader = new FileReader()
      reader.onload = (e) => {
        try {
          const data = e.target.result
          const XLSX = require('xlsx')
          const workbook = XLSX.read(data, { type: 'array' })
          const firstSheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[firstSheetName]

          const excelData = XLSX.utils.sheet_to_json(worksheet, {
            header: ['id', 'price', 'name', 'desc', 'cid'], range: 1
          })
          if (excelData.length === 0) {
            return this.$message.warning('Excel文件中没有数据')
          }

          excelData.forEach(row => {
            if (row.id !== undefined && row.id !== null) {
              row.id = String(row.id).trim()
            }
            if (row.price !== undefined && row.price !== null) {
              row.price = Number(row.price)
            }
            if (row.cid !== undefined && row.cid !== null) {
              row.cid = String(row.cid).trim()
            }
          })

          this.mergeProducts(excelData)
          this.syncToForm()
          this.$message.success('导入成功')
        } catch (error) {
          console.error('解析Excel文件失败:', error)
          this.$message.error('解析Excel文件失败')
        }
      }
      reader.onerror = () => {
        this.$message.error('读取文件失败')
      }
      reader.readAsArrayBuffer(uploadFile.raw)
    },
    // JSON自动转换导入
    handleFormatJson () {
      if (!this.textarea) {
        return this.$message.info('请输入内容')
      }
      if (typeof this.textarea !== 'string') {
        return this.$message.info('请输入字符串类型')
      }
      if (this.isJsonString(this.textarea)) {
        const parsed = JSON.parse(this.textarea)
        if (Array.isArray(parsed)) {
          this.products = parsed.map(item => ({
            id: item.id === undefined || item.id === null ? '' : String(item.id),
            price: item.price,
            name: item.name || '',
            desc: item.desc || '',
            cid: item.cid || ''
          }))
          this.syncToForm()
          this.jsonMode = 'view'
          this.$message.success('JSON 已应用')
        } else {
          this.$message.warning('请输入JSON对象数组')
        }
      } else {
        return this.$message.info('请输入正确格式的JSON数据')
      }
    },
    mergeProducts (incoming) {
      const oldMap = new Map(this.products.filter(item => item.id).map(item => [String(item.id), item]))
      const blankRows = this.products.filter(item => !item.id)
      for (const item of incoming) {
        if (!item || item.id === undefined || item.id === null || !String(item.id).trim()) continue
        const idKey = String(item.id).trim()
        if (oldMap.has(idKey)) {
          Object.assign(oldMap.get(idKey), item, { id: idKey })
        } else {
          oldMap.set(idKey, Object.assign({}, item, { id: idKey }))
        }
      }
      this.products = Array.from(oldMap.values()).concat(blankRows)
    },
    isJsonString (str) {
      try {
        const obj = JSON.parse(str)
        if (typeof obj === 'object' && obj !== null) {
          return true
        }
      } catch (e) {
      }
      return false
    }
  }
}
</script>

<style scoped>
.form-section {
  padding: 18px 0 20px;
  border-bottom: 1px solid var(--border-color);
}

.form-section:first-child {
  padding-top: 0;
}

.form-section:last-child {
  padding-bottom: 0;
  border-bottom: 0;
}

.table-container {
  border: 1px solid var(--border-color);
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 0;
  width: 100%;
}

.premium-table {
  color: var(--text-main) !important;
  font-size: 13px !important;
}

.inline-edit-table :deep(.el-table__header-wrapper) th {
  background-color: var(--bg-page) !important;
  color: var(--text-muted) !important;
  font-weight: 700 !important;
  padding: 9px 0 !important;
  border-bottom: 1px solid var(--border-color) !important;
}

.inline-edit-table :deep(.el-table__fixed-right .el-table__fixed-header-wrapper th),
.inline-edit-table :deep(.el-table__fixed-right-patch) {
  background-color: var(--bg-page) !important;
  color: var(--text-muted) !important;
  font-weight: 700 !important;
  padding: 9px 0 !important;
  border-bottom: 1px solid var(--border-color) !important;
}

.inline-edit-table :deep(.el-table__fixed-right .el-table__fixed-body-wrapper td) {
  background-color: var(--bg-card);
}

.inline-edit-table :deep(.el-table__row) td {
  padding: 7px 0 !important;
}

.panel-section-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.compact-header {
  align-items: flex-start;
}

.panel-title-icon {
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 8px;
  background: var(--bg-tip-hover);
  color: var(--primary-color);
}

.panel-section-title {
  margin: 0;
  color: var(--text-main);
  font-size: 15px;
  font-weight: 700;
  line-height: 22px;
}

.section-subtitle {
  margin: 2px 0 0;
  color: var(--text-muted);
  font-size: 12.5px;
  line-height: 18px;
}

.toolbar-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 14px;
  margin-bottom: 0;
}

.upload-inline {
  display: inline-block;
}

.btn-primary-action {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
}

.btn-primary-action:hover {
  background-color: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
}

.json-mode-switch {
  flex-shrink: 0;
  margin-left: auto;
}

.json-preview {
  min-height: 120px;
  max-height: 320px;
  overflow: auto;
  margin: 0;
  padding: 14px;
  border-radius: 8px;
  background: #0f172a;
  color: #e2e8f0;
  border: 1px solid var(--border-color);
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12.5px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
}

.code-textarea :deep(.el-textarea__inner) {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12.5px;
  background-color: var(--bg-card);
  border-color: var(--border-color);
  color: var(--text-main);
}

.section-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>
